import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
@Component({
  selector: 'app-user-overview',
  templateUrl: './user-overview.component.html',
  styleUrls: ['./user-overview.component.scss']
})
export class UserOverView implements OnInit {

  @Input() dataReport: any
  title_report = 'Thống kê bài đăng theo vị trí';


  public doughnutChartOptions: any = {
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 4,
        fontStyle: 'bold'
      }
    }
  }
  public doughnutChartType = 'doughnut';
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#0071c1", "#ffc001", "#800080", "#006400"] }
  ];
  public doughnutChartLabels = ['Miền Bắc', 'Miền Trung', 'Miền Nam', 'Không Xác Định'];
  public doughnutChartData = [
    [0,0,0,0]
  ];
  tong_thao_luan = 0;
  provinces = [];

  htmlRight = '';
;

  

  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
 
      
      this.doughnutChartData = [this.dataReport.data.mbCount,this.dataReport.data.mtCount,this.dataReport.data.mnCount,this.dataReport.data.otherCount]
      this.tong_thao_luan = this.dataReport.data.totalCount ;
      this.provinces = this.dataReport.data.provinces ;


      this.htmlRight = this.dataReport.data.htmlRight;
      // this.htmlNews = this.dataReport.data.htmlNews;
 
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/user-overview/user-overview.component.ts